module.exports = __webpack_public_path__ + "r-v3/img/arrow_down_triangular_filled.f1519fe8.svg";